import {
  DenseTableRowProps,
  omitExtraRowColumns
} from '../../../../../components'
import {
  EmploymentInput,
  MutationSaveEmploymentsDataArgs
} from '../../../../../utils/classes/graphql'
import { getNewAndChangedEmploymentRows } from '../helpers'
import {
  EmploymentData,
  EmploymentRowProps,
  EmploymentsTableProps
} from '../types'
import { validationSchema } from '../validation/validation-schema'

const createEmploymentInputRow = (employment: EmploymentRowProps) => {
  const employmentInput: EmploymentInput = {
    ...omitExtraRowColumns<EmploymentData>(employment, [
      'paatoiminenText',
      'taPerintaText'
    ])
  }
  return employmentInput
}

export const useEmploymentFormData = (
  employmentArray: DenseTableRowProps<EmploymentData>[]
) => {
  const initialValues = { tyosuhteet: employmentArray }

  const createVariables = (
    values: EmploymentsTableProps
  ): MutationSaveEmploymentsDataArgs => {
    // filter changed and new rows
    const newAndChangedEmploymentRows = getNewAndChangedEmploymentRows(
      values.tyosuhteet,
      initialValues.tyosuhteet
    )

    // filter out unnecessary row columns
    const employmentInputRows = newAndChangedEmploymentRows.map(
      (employment: EmploymentRowProps) => createEmploymentInputRow(employment)
    )

    // All values must be declared in api's input
    return {
      employmentsData: {
        tyosuhteet: employmentInputRows
      }
    }
  }

  return { createVariables, initialValues, validationSchema }
}
